import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Image } from "@opensea/next-ui-kit";
import { classNames, FlexColumn, insetBorderVariants, TextBody, TextHeading } from "@opensea/ui-kit";
export const WhatsNewModalSlideFragment = graphql(`
  fragment WhatsNewModalSlide on Announcement {
    id
    title
    description
    imageUrl
  }
`);
function extractFirstLine(html) {
  const normalized = html.replace(P_OPEN_REGEX, "").replace(P_CLOSE_REGEX, "\n").replace(BR_REGEX, "\n");
  const newlineIndex = normalized.indexOf("\n");
  return newlineIndex === -1 ? normalized : normalized.slice(0, newlineIndex);
}
function extractYouTubeIdFromText(text) {
  // Match common YouTube URL formats
  for (const pattern of YT_PATTERNS) {
    const match = text.match(pattern);
    if (match?.[1]) {
      return match[1];
    }
  }
  return null;
}

// Hoisted regex patterns for performance and lint compliance
const P_OPEN_REGEX = /<p[^>]*>/i;
const P_CLOSE_REGEX = /<\/p>/i;
const BR_REGEX = /<br\s*\/?>(?=.)/gi;
const YT_PATTERNS = [/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([A-Za-z0-9_-]{11})/i, /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?[^\s]*v=([A-Za-z0-9_-]{11})/i, /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([A-Za-z0-9_-]{11})/i, /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/i];
const YT_ANCHOR_TAG_REGEX = /<a\b[^>]*href=(['"]).*?(?:youtu\.be|youtube\.com).*?\1[^>]*>.*?<\/a>/gi;
const YT_PLAIN_URL_REGEX = /https?:\/\/(?:www\.)?(?:youtu\.be|youtube\.com)\S*/gi;
const EMPTY_P_TAG_REGEX = /<p[^>]*>\s*<\/p>/gi;
export function WhatsNewModalSlide(t0) {
  const $ = _c(20);
  const {
    slide: slideKey,
    isActive
  } = t0;
  let slide;
  let t1;
  let youtubeId;
  if ($[0] !== slideKey) {
    slide = readFragment(WhatsNewModalSlideFragment, slideKey);
    const firstLine = extractFirstLine(slide.description ?? "");
    youtubeId = extractYouTubeIdFromText(firstLine);
    t1 = youtubeId ? (slide.description ?? "").replace(YT_ANCHOR_TAG_REGEX, "").replace(YT_PLAIN_URL_REGEX, "").replace(EMPTY_P_TAG_REGEX, "") : slide.description;
    $[0] = slideKey;
    $[1] = slide;
    $[2] = t1;
    $[3] = youtubeId;
  } else {
    slide = $[1];
    t1 = $[2];
    youtubeId = $[3];
  }
  const cleanedDescription = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("relative rounded bg-bg-primary p-1.5", insetBorderVariants({
      positioning: "absolute"
    }));
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isActive || $[6] !== slide.imageUrl || $[7] !== slide.title || $[8] !== youtubeId) {
    t3 = <div className={t2}>{youtubeId ? <div className={classNames("overflow-hidden rounded-xs p-px", insetBorderVariants())}><div className="pointer-events-none relative aspect-video w-full overflow-hidden rounded-xs bg-black">{isActive && <iframe allow="autoplay; encrypted-media; picture-in-picture" className="absolute top-[-100%] h-[300%] w-full" loading="lazy" src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=1&showinfo=0&controls=0&rel=0&modestbranding=1&playsinline=1&loop=1&playlist=${youtubeId}&iv_load_policy=3`} title={slide.title ?? "What's New video"} />}</div></div> : <Image className={classNames("overflow-hidden rounded-xs p-px", insetBorderVariants())} height={3147} src={slide.imageUrl} width={5568} />}</div>;
    $[5] = isActive;
    $[6] = slide.imageUrl;
    $[7] = slide.title;
    $[8] = youtubeId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== slide.title) {
    t4 = <TextHeading size="md">{slide.title}</TextHeading>;
    $[10] = slide.title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = cleanedDescription ?? "";
  let t6;
  if ($[12] !== t5) {
    t6 = <TextBody color="text-secondary" dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <FlexColumn className="gap-2">{t4}{t6}</FlexColumn>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t7) {
    t8 = <FlexColumn className="w-[100vw] min-w-[100vw] gap-6 p-6 pb-8 md:w-[540px] md:min-w-[540px]">{t3}{t7}</FlexColumn>;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}